import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import StatusBadge from "@/components/StatusBadge";
import { Lock, ChevronRight } from "lucide-react";

export default function RelatedTests({ testId }) {
  const [items, setItems] = useState(null);

  useEffect(() => {
    if (!testId) return;
    api
      .get(`/tests/${testId}/related`)
      .then((res) => setItems(res.data))
      .catch(() => setItems([]));
  }, [testId]);

  if (!items || items.length <= 1) return null; // nothing to show if this is the only one

  return (
    <div
      className="no-print max-w-4xl mx-auto mt-6 border border-[#33424f]/20 bg-white"
      data-testid="related-tests-rail"
    >
      <div className="px-6 py-4 border-b border-[#33424f]/20 bg-[#f5f1ec]">
        <div className="eyebrow">/ Repair history</div>
        <h3 className="font-display text-2xl tracking-tight text-[#33424f] leading-none mt-1">
          RELATED TESTS ON THIS VESSEL
        </h3>
        <p className="font-body text-xs text-[#50493b] mt-2">
          {items.length} record{items.length === 1 ? "" : "s"} on this job + vessel — including
          re-tests after repair or replacement.
        </p>
      </div>
      <ul className="divide-y divide-[#33424f]/10">
        {items.map((t) => {
          const active = t.id === testId;
          return (
            <li key={t.id}>
              <Link
                to={`/tests/${t.id}/certificate`}
                data-testid={`related-${t.id}`}
                className={`flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 sm:gap-0 px-4 sm:px-6 py-3 transition-colors ${
                  active ? "bg-[#e6f3ff]" : "hover:bg-[#f5f1ec] active:bg-[#f5f1ec]"
                }`}
              >
                <div className="flex flex-wrap items-center gap-2 sm:gap-4 min-w-0">
                  <div className="mono subtitle text-sm text-[#33424f] shrink-0">
                    JST-{t.id.slice(0, 8).toUpperCase()}
                  </div>
                  {t.blown_out_employee_id && (
                    <Lock className="w-3.5 h-3.5 text-[#33424f] shrink-0" />
                  )}
                  <StatusBadge status={t.status} size="sm" />
                  {active && (
                    <span className="subtitle text-[10px] uppercase tracking-[0.2em] text-[#39678f]">
                      Currently viewing
                    </span>
                  )}
                </div>
                <div className="flex items-center justify-between sm:justify-end gap-3 sm:gap-4 font-body text-xs text-[#50493b] flex-wrap sm:flex-nowrap">
                  <span className="sm:hidden text-[10px] subtitle uppercase tracking-[0.2em] text-[#50493b]/70">
                    {t.test_date || "—"} · {t.test_pressure || "—"} · {t.test_medium || "—"}
                  </span>
                  <span className="hidden sm:inline">{t.test_date || "—"}</span>
                  <span className="hidden sm:inline">{t.test_pressure || "—"}</span>
                  <span className="hidden sm:inline">{t.test_medium || "—"}</span>
                  <ChevronRight className="w-4 h-4 text-[#ccb795] shrink-0" />
                </div>
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
